module.exports = __webpack_public_path__ + "img/xiahua.0f28a3f9.svg";